import { useNavigate, useSearchParams } from "react-router-dom";
import { DeepLinkValues } from "../../app/constants";
import { useEffect } from "react";
import { CircularProgress } from "@mui/material";

export const Redirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const deepLinkValue = searchParams.get("deep_link_value");

  // Dev note: these are all the same right now, but in the future when the
  // dynamic links are expanded upon, they can go to different places.
  useEffect(() => {
    if (deepLinkValue === DeepLinkValues.ASSESSMENT_REQUESTED) {
      // "Pending Assessments" is accessed from the home directory
      navigate("/");
    } else if (deepLinkValue === DeepLinkValues.ASSESSMENT_COMPLETED) {
      // Until "Assessment History" is created on web, completed assessment
      // notifications will just take the user to the home screen.
      navigate("/");
    } else {
      // Dynamic links should default to the home screen.
      navigate("/");
    }
  }, [deepLinkValue]);

  return <CircularProgress />;
};
